import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen bg-[#0F1012] grain" data-testid="payment-cancel-page">
      <header className="border-b border-[#2E3340]">
        <div className="max-w-6xl mx-auto px-6 h-20 flex items-center">
          <Logo />
        </div>
      </header>
      <div className="flex items-center justify-center px-6 py-20">
        <div className="max-w-lg w-full border border-[#2E3340] bg-[#1E2128] p-10 text-center">
          <span className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-zinc-700 mb-6">
            <X className="text-zinc-500" size={22} />
          </span>
          <p className="font-mono-lux text-[10px] font-semibold uppercase tracking-[0.35em] text-zinc-500">Checkout Cancelled</p>
          <h1 className="font-serif-lux text-4xl text-amber-50 mt-3" data-testid="payment-cancel-heading">No charge was made.</h1>
          <p className="mt-4 text-sm text-zinc-300 leading-relaxed">
            Your reservation stands — our concierge will still confirm it personally.
            You can pay the deposit anytime from your confirmation page.
          </p>
          <Link
            to="/"
            data-testid="payment-cancel-home-link"
            className="inline-block mt-8 font-mono-lux text-[10px] font-semibold uppercase tracking-[0.3em] px-6 py-3 border border-amber-500/40 text-amber-300 hover:bg-amber-500 hover:text-black transition-colors"
          >
            Return Home
          </Link>
        </div>
      </div>
    </main>
  );
}
